export default "__VITE_ASSET__8uyeAsjx__"